import defaults from '@mailobj-browser/front/js/selectors/defaults.js'

export default defaults.root.getAttribute('data-skin')
